import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import AboutPage from "../AboutPage/AboutPage";
import FaqPage from "../FaqPage/FaqPage";
import ServicePages from "../ServicePage/ServicePage";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";
import ProjectPage from '../ProjectPage/ProjectPage';
import GalleryPage from "../GalleryPage/GalleryPage";
import ProjectSingle from '../ProjectSingle/ProjectSingle';

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="portfolio" element={<ProjectPage />} />
          <Route path="portfolio/:slug" element={<ProjectSingle />} />
          <Route path="services" element={<ServicePages />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="404" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
